/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './facility-location.reducer';

export const FacilityLocationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const facilityLocationEntity = useAppSelector(state => state.facilityLocation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="facilityLocationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.facilityLocation.detail.title">FacilityLocation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.id">Id</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.active">Active</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.cursor}</dd>
          <dt>
            <span id="facilityType">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.facilityType">Facility Type</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.facilityType}</dd>
          <dt>
            <span id="facilityId">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.facilityId">Facility Id</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.facilityId}</dd>
          <dt>
            <span id="locationType">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.locationType">Location Type</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.locationType}</dd>
          <dt>
            <span id="locationId">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.locationId">Location Id</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.locationId}</dd>
          <dt>
            <span id="businessType">
              <Translate contentKey="tinyMedicRestApp.facilityLocation.businessType">Business Type</Translate>
            </span>
          </dt>
          <dd>{facilityLocationEntity.businessType}</dd>
        </dl>
        <Button tag={Link} to="/facility-location" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/facility-location/${facilityLocationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default FacilityLocationDetail;
